module.exports = __webpack_public_path__ + "img/nature_pin.53cd2585.png";